export default function CopyCircle({ className, backgroundColor }) {
    return (
      <svg className={className} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8" cy="8" r="8" fill={backgroundColor} />
        <circle cx="7.99903" cy="4.59192" r="1.21973" fill="currentColor" />
        <rect x="7.10156" y="7.24677" width="1.79372" height="5.38117" fill="currentColor" />
      </svg>
    )
}
